import { LatLngLiteral } from "leaflet"
import React, {
  // useMemo,
  useState,
} from "react"
import {
  MapContainer,
  Marker,
  Polyline,
  Popup,
  TileLayer,
  Tooltip,
} from "react-leaflet"
import style from "./Map.module.scss"
import {
  barIcon_star,
  // serviceIcon
} from "../data/icons"
import { Mile, miles } from "../data/miles"
import { RadioButtonComponent } from "./RadioButton"
import { MileId } from "../data/enums"
import { bars } from "../data/bars"
import { Link } from "react-router-dom"
require("/node_modules/leaflet/dist/leaflet.css")

// City center
// const startPosition: LatLngLiteral = {
//   lat: 56.83790525833942,
//   lng: 60.596262216568,
// }

// Center of markers
const startPosition: LatLngLiteral = {
  lat: 56.82844108647872,
  lng: 60.59670746326447,
}

export const MapComponent: React.FC = () => {
  // const eventHandlers = useMemo(
  //   () => ({
  //     dragend(event: any) {
  //       console.log(event.target._latlng)
  //     },
  //   }),
  //   []
  // )

  const [filter, setFiler] = useState(MileId.AllMiles)

  const onSelectFilter = (value: MileId) => {
    // @ts-ignore
    ym(92771670, "reachGoal", "filterClick")
    setFiler(value)
  }

  const barLinkClickEvent = () => {
    // @ts-ignore
    ym(92771670, "reachGoal", "barLinkClick")
  }

  const milesToShow = () => {
    if (filter === MileId.AllBars) {
      const allBarsMiles: Mile[] = [
        {
          title: "Все бары",
          id: MileId.Mile2,
          paths: false,
          date: "?",
          done: true,
          icon: barIcon_star,
          image: "extra",
          diggers: [],
          bars: bars.map((bar) => bar.id),
        },
      ]
      return allBarsMiles
    }
    if (filter === MileId.AllMiles) return miles
    if (
      [
        MileId.Mile1,
        MileId.Mile2,
        MileId.Mile25,
        MileId.Mile3,
        MileId.Mile4,
        MileId.Mile5,
        MileId.Mile6,
        MileId.Mile7,
      ].includes(filter)
    ) {
      return miles.filter((mile) => mile.id === filter)
    }
    return miles
  }

  return (
    <div className={style.mapComponent}>
      <div className={style.controls}>
        <div className={style.radioButtons}>
          <RadioButtonComponent
            title="Все мили"
            name="filter"
            value={MileId.AllMiles}
            checked={filter === MileId.AllMiles}
            onChange={onSelectFilter}
          />
          {miles.map((mile, index) => (
            <RadioButtonComponent
              key={index}
              title={mile.title}
              name="filter"
              value={mile.id}
              checked={filter === mile.id}
              onChange={onSelectFilter}
            />
          ))}
          <RadioButtonComponent
            title="Все бары"
            name="filter"
            value={MileId.AllBars}
            checked={filter === MileId.AllBars}
            onChange={onSelectFilter}
          />
        </div>
      </div>

      <div className={style.map}>
        <MapContainer
          center={startPosition}
          zoom={15}
          scrollWheelZoom={true}
          style={{ height: "100%", width: "80vw" }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {milesToShow().map((mile, index0) => {
            return (
              <div key={index0}>
                {mile.bars.map((barId, index1) => {
                  const barToRender = bars.find((bar) => bar.id === barId)
                  if (!barToRender) return <></>
                  return (
                    <Marker
                      key={index1}
                      icon={mile.icon}
                      position={barToRender.latlng}
                    >
                      <Popup>
                        {barToRender.address}
                        <br />
                        {barToRender.info && (
                          <Link
                            to={`/bars/${barToRender.id}`}
                            onClick={barLinkClickEvent}
                          >
                            <h3>Открыть страницу бара</h3>
                          </Link>
                        )}
                      </Popup>
                      <Tooltip
                        direction="bottom"
                        offset={[0, 5]}
                        opacity={1}
                        permanent
                        className={style.popup}
                      >
                        {barToRender.title}
                      </Tooltip>
                    </Marker>
                  )
                })}
                {mile.paths &&
                  mile.bars.map((barId, index, array) => {
                    const barToRender = bars.find((bar) => bar.id === barId)
                    const prevBarToRender = bars.find(
                      (bar) => bar.id === array[index - 1]
                    )
                    if (!array[index - 1]) return <></>
                    if (!barToRender || !prevBarToRender) return <></>
                    return (
                      <Polyline
                        positions={[barToRender.latlng, prevBarToRender.latlng]}
                        color="red"
                        key={index}
                      />
                    )
                  })}
              </div>
            )
          })}
          {/* <Marker
            // service marker
            icon={serviceIcon}
            position={startPosition}
            eventHandlers={eventHandlers}
            draggable
          ></Marker> */}
        </MapContainer>
      </div>
    </div>
  )
}
